import { Link } from 'react-router-dom';
import type { Feature } from './features';

export function Tile({ f }: { f: Feature }) {
  const body = (
    <>
      <span className="tile-icon" aria-hidden>{f.icon}</span>
      <strong>{f.label}</strong>
      <span className="tile-sub">{f.ready ? f.sub : `Coming in phase ${f.phase}`}</span>
    </>
  );
  if (f.ready && f.to) return <Link className="tile" to={f.to} data-feature={f.id}>{body}</Link>;
  return <div className="tile" aria-disabled="true" data-feature={f.id}>{body}</div>;
}
